var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-3 pt-0 pb-0 position-relative"},[(_vm.categoriesAreWithImage && !_vm.smAndDown)?[_c('div',{staticClass:"d-flex justify-center mt-8"},_vm._l((_vm.categories),function(ref){
var id = ref.id;
var title = ref.title;
var img = ref.img;
return _c('ProductCategoryCard',{key:id,attrs:{"title":title,"img":_vm.files + img.featured}})}),1)]:[_c('div',{staticClass:"d-flex mx-n3 position-relative item-categories"},[_c('v-slide-group',{class:{
          'mx-auto': !_vm.smAndDown,
        },attrs:{"center-active":"","mandatory":"","show-arrows":!_vm.smAndDown},model:{value:(_vm.slideGroupModel),callback:function ($$v) {_vm.slideGroupModel=$$v},expression:"slideGroupModel"}},_vm._l((_vm.categories),function(ref,keyCategories){
        var title = ref.title;
return _c('v-slide-item',{key:keyCategories,scopedSlots:_vm._u([{key:"default",fn:function(ref){
        var active = ref.active;
        var toggle = ref.toggle;
return [_c('v-btn',{staticClass:"text-body-1 text-none pa-2 position-relative item-category",class:[
              active
                ? 'primary--text item-category-active'
                : 'grey--text text--darken-2',

              keyCategories !== 0 ? 'ml-3' : '' ],attrs:{"ripple":false,"min-width":"0","color":"transparent","depressed":"","tile":""},on:{"click":toggle}},[_vm._v(" "+_vm._s(title)+" ")])]}}],null,true)})}),1)],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }